module.exports = "\n.mat-list-icon {\n  color: rgba(0, 0, 0, 0.54);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/docpage/docpage/docpage.component.css
// module id = ./src/app/pages/docpage/docpage/docpage.component.css
// module chunks = main